<template>
  <AbstractTaskModalComponent :task="action" :event="event" :disabled="disabled">
    <template v-if="meta != null" #beforeStatus>
      <EventActionFieldRowComponent
        v-for="(attribute, index) in customAttributes"
        :key="`customAttr${index}`"
        :label="`${attribute}`"
      >
        <InputRow
          v-slot="{ field: inputField, validation: { valid } }"
          v-model="meta.customAttributes[attribute].value"
          :required="meta.customAttributes[attribute].required"
          :name="`${attribute.replaceAll(' ', '')}${index}`"
        >
          <InputTextArea
            v-bind="inputField"
            v-model="meta.customAttributes[attribute].value"
            :rows="1"
            class="w-100"
            :disabled="disabled"
            :state="valid"
            @keydown.meta.enter="$emit('save', $event)"
            @keydown.ctrl.enter="$emit('save', $event)"
          />
        </InputRow>
      </EventActionFieldRowComponent>
    </template>
    <slot />
  </AbstractTaskModalComponent>
</template>

<script setup lang="ts">
import InputRow from "@/components/shared/form/InputRow.vue";
import { type PropType, computed } from "vue";
import InputTextArea from "primevue/textarea";
import AbstractTaskModalComponent from "./AbstractTaskModalComponent.vue";
import EventActionFieldRowComponent from "../../EventActionFieldRowComponent.vue";
import type { EditTaskType } from "../helper/DefaultTask";
import type { EventListEventFieldsFragment } from "@/graphql";
import type { EventEditType } from "../../event/modal/EventEditType";

const props = defineProps({
  action: {
    type: Object as PropType<EditTaskType>,
    required: true,
  },
  event: {
    type: Object as PropType<EventListEventFieldsFragment | EventEditType>,
    required: true,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
});
defineEmits(["save"]);

const meta = computed(() =>
  props.action.meta?.__typename === "CustomTaskMeta" ? props.action.meta : undefined,
);

const customAttributes = computed<string[]>(() =>
  props.action.meta?.__typename === "CustomTaskMeta"
    ? Object.keys(props.action.meta.customAttributes)
    : [],
);
</script>

<style lang="scss" scoped></style>
